(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["forest-walk"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initForest = (root) => {
      if (!root || root.dataset.forestReady) return;
      root.dataset.forestReady = 'true';
      const scene = root.querySelector('.forest-walk__scene');
      const toggle = root.querySelector('[data-motion-toggle]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let pointerX = 0;
      let pointerY = 0;
      let ticking = false;

      const render = () => {
        const rect = root.getBoundingClientRect();
        const distance = rect.height + window.innerHeight;
        const progress = Math.max(0, Math.min(1, (window.innerHeight - rect.top) / distance));
        scene.style.setProperty('--forest-x', pointerX.toFixed(3));
        scene.style.setProperty('--forest-y', pointerY.toFixed(3));
        scene.style.setProperty('--forest-walk', progress.toFixed(3));
        ticking = false;
      };

      const requestRender = () => {
        if (!ticking && !reduceMotion.matches) {
          ticking = true;
          window.requestAnimationFrame(render);
        }
      };

      root.addEventListener('pointermove', (event) => {
        const rect = root.getBoundingClientRect();
        pointerX = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        pointerY = ((event.clientY - rect.top) / Math.min(rect.height, window.innerHeight)) * 2 - 1;
        requestRender();
      }, { passive: true });

      root.addEventListener('pointerleave', () => {
        pointerX = 0;
        pointerY = 0;
        requestRender();
      }, { passive: true });

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });

      if (toggle) {
        toggle.addEventListener('click', () => {
          const paused = scene.classList.toggle('is-paused');
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.textContent = paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel;
        });
      }

      requestRender();
    };

    const initAllForests = (scope = document) => {
      scope.querySelectorAll('[data-forest-walk]').forEach(initForest);
    };

    initAllForests();
    document.addEventListener('shopify:section:load', (event) => initAllForests(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.header-collections[open],.mobile-collections[open]').forEach(menu=>menu.removeAttribute('open'))});
document.addEventListener('click',event=>{document.querySelectorAll('.header-collections[open]').forEach(menu=>{if(!menu.contains(event.target))menu.removeAttribute('open')})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-collection-select]')) return;
    if (event.target.value) window.location.assign(event.target.value);
  });

  } catch(e) { console.error(e); }
})();
})();
